/* eslint-disable  */
import React, {memo} from 'react';
import T from 'prop-types';
import {
  DashboardDays,
  DashboardField,
  DashboardFields,
  DialogField
} from 'routes/App/dashboard/styles';
import DaysPickerDays from 'routes/App/discountsV2/DiscountWizard/DateAvailability/DaysPickerDays';
import DaysPickerTimeSelect from 'routes/App/discountsV2/DiscountWizard/DateAvailability/DaysPickerTimeSelect';

const DayItem = ({day}) => {
  return (
    <>
      <DashboardFields className='w100 AlignCenter'>
        <DashboardField className='wAuto'>
          <DashboardDays>
            <DaysPickerDays day={day} />
          </DashboardDays>
        </DashboardField>

        <DashboardField className='wAuto'>
          <DaysPickerTimeSelect timePeriods={day.timePeriods} day={day} />
        </DashboardField>
      </DashboardFields>
    </>
  );
};

DayItem.propTypes = {
  day: T.object.isRequired
};

DayItem.defaultProps = {};

export default memo(DayItem);
